import {observer} from 'mobx-react-lite'
import React from 'react'
import {TablerIcons} from '@components/common/icon-tabler/icon-tabler'
import {trackPageClick} from '@components/main-menu/handlers/tracking'
import {Page} from '@extensions/page'
import {goto} from '../handlers/main-handlers'
import {useMainMenuStore} from '../main-menu-store'
import {Direction} from './arrow-button'
import {MenuButtonWithContent} from './menu-button-with-content'

interface Props {
  page: Page
  text: string
  icon: TablerIcons

  count?: string
  countMarked?: boolean

  withArrow?: boolean
  arrowCb?: (e: React.MouseEvent) => void
  arrowDirection?: Direction
  after?: React.ReactNode
}

export const MenuButtonPage = observer(({page, ...props}: Props) => {
  const [state] = useMainMenuStore()
  const {currentPage} = state

  const gotoPage = () => {
    goto(page)
    trackPageClick(page)
  }
  const isCurrentPage = currentPage === page

  return (
    <MenuButtonWithContent
      active={isCurrentPage}
      onClick={gotoPage}
      {...props}
    />
  )
})
